import React from 'react';
import { Redirect, Route, useHistory, useRouteMatch } from 'react-router-dom';
import { ERoutes } from '../../../routes';
import {
  IConstructionData,
  IConstructionRegistrationState,
  IDeliveryConditions
} from '../../../store/ducks/contracts-and-constructions/types';
import { IResponsibleOfConstruction } from '../../../store/ducks/fabrication-contracts/types';
import { EConstructionsRoutes } from '../contractsAndConstructions.routes';
import Checkout from './Checkout';
import ConstructionData from './ConstructionData';
import DeliveryConditions from './DeliveryConditions';
import RegistrationSuccess from './RegistrationSuccess';
import { Container } from './styles';
import ResponsibleOfConstruction from './ResponsibleOfConstruction';

export enum EConstructionRegistrationRoutes {
  CONSTRUCTION_DATA = '/contruction-data',
  DELIVERY_CONDITIONS = '/delivery-conditions',
  RESPONSIBLE_OF_CONSTRUCTION = '/responsible-of-construction',
  CHECKOUT = '/checkout',
  SUCCESS = '/success'
}

interface IConstructionRegistrationRoutesProps {
  constructionRegistration: IConstructionRegistrationState;
  constructionData?: IConstructionData;
  setConstructionData(constructionData: IConstructionData): void;
  deliveryConditions: IDeliveryConditions;
  setDeliveryConditions(deliveryConditions: IDeliveryConditions): void;
  responsiblesOfConstruction: IResponsibleOfConstruction[];
  setResponsiblesOfConstruction(
    responsiblesOfConstruction: IResponsibleOfConstruction[]
  ): void;
}

const ConstructionRegistrationRoutes: React.FC<
  IConstructionRegistrationRoutesProps
> = ({
  constructionRegistration,
  constructionData,
  setConstructionData,
  deliveryConditions,
  setDeliveryConditions,
  responsiblesOfConstruction,
  setResponsiblesOfConstruction
}) => {
  const history = useHistory();
  const { path } = useRouteMatch();

  const goToConstructionRegistrationRoute = (
    route: EConstructionRegistrationRoutes
  ) => {
    history.push(
      `${ERoutes.CONTRACTS_AND_CONSTRUCTIONS}${
        EConstructionsRoutes.CONSTRUCTION_REGISTRATION
      }${route || ''}`
    );
  };

  return (
    <>
      <Route
        path={`${path}${EConstructionRegistrationRoutes.CONSTRUCTION_DATA}`}
        render={() => (
          <ConstructionData
            contractNumber={constructionRegistration.contractNumber}
            constructionData={constructionData}
            setConstructionData={setConstructionData}
            goToConstructionRegistrationRoute={
              goToConstructionRegistrationRoute
            }
          />
        )}
      />
      <Container isFacelift>
        <Route
          path={`${path}${EConstructionRegistrationRoutes.DELIVERY_CONDITIONS}`}
          render={() => (
            <DeliveryConditions
              goToConstructionRegistrationRoute={
                goToConstructionRegistrationRoute
              }
              deliveryConditions={deliveryConditions}
              setDeliveryConditions={setDeliveryConditions}
            />
          )}
        />

        <Route
          path={`${path}${EConstructionRegistrationRoutes.RESPONSIBLE_OF_CONSTRUCTION}`}
          render={() => (
            <ResponsibleOfConstruction
              goToConstructionRegistrationRoute={
                goToConstructionRegistrationRoute
              }
              responsiblesOfConstruction={responsiblesOfConstruction}
              setResponsiblesOfConstruction={setResponsiblesOfConstruction}
            />
          )}
        />

        <Route
          path={`${path}${EConstructionRegistrationRoutes.CHECKOUT}`}
          render={() => (
            <Checkout
              goToConstructionRegistrationRoute={
                goToConstructionRegistrationRoute
              }
              constructionRegistration={constructionRegistration}
            />
          )}
        />
        <Route
          path={`${path}${EConstructionRegistrationRoutes.SUCCESS}`}
          render={() => <RegistrationSuccess />}
        />

        <Route path="*">
          <Redirect
            to={`${path}${EConstructionRegistrationRoutes.CONSTRUCTION_DATA}`}
          />
        </Route>
      </Container>
    </>
  );
};

export default ConstructionRegistrationRoutes;
